import { render, staticRenderFns } from "./PopupMessageList.vue?vue&type=template&id=d24a15fa"
import script from "./PopupMessageList.vue?vue&type=script&lang=js"
export * from "./PopupMessageList.vue?vue&type=script&lang=js"
import style0 from "./PopupMessageList.vue?vue&type=style&index=0&id=d24a15fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../4rahgit/GPS-Tracking-Client-Panel/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports